import React, { useState, useEffect } from 'react';
import FileService from '../services/FileService';
import './RasaIntentManager.css';

const RasaMonitor = ({ onClose }) => {
    const [servers, setServers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchServerStatus = async () => {
        try {
            setLoading(true);
            setError(null);
            const status = await FileService.getRasaServerStatus();
            setServers(status);
        } catch (err) {
            console.error('Error fetching RASA server status:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleStopServer = async (port) => {
        if (!window.confirm(`Are you sure you want to stop the AI server on port ${port}?`)) {
            return;
        }

        try {
            await FileService.stopRasaServer(port);
            alert(`Server on port ${port} stopped successfully`);
            fetchServerStatus(); // Refresh the list
        } catch (err) {
            alert(`Failed to stop server: ${err.message}`);
        }
    };

    useEffect(() => {
        fetchServerStatus();

        // Auto-refresh every 10 seconds
        const interval = setInterval(fetchServerStatus, 10000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="rasa-manager-overlay">
            <div className="rasa-manager-dialog" style={{ maxWidth: '800px' }}>
                <div className="rasa-manager-header">
                    <h2>AI Server Monitor</h2>
                    <button onClick={onClose} className="delete-btn" style={{ fontSize: '2rem' }}>×</button>
                </div>

                <div className="rasa-manager-content">
                    {loading && servers.length === 0 && (
                        <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>
                            Loading server status...
                        </div>
                    )}

                    {error && (
                        <div style={{ padding: '2rem', textAlign: 'center', color: '#dc3545' }}>
                            Error: {error}
                        </div>
                    )}

                    {!loading && servers.length === 0 && !error && (
                        <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>
                            No AI servers are currently running.
                        </div>
                    )}

                    {servers.length > 0 && (
                        <div style={{ padding: '1.5rem' }}>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                            }}>
                                <thead>
                                    <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600 }}>Port</th>
                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600 }}>Organization</th>
                                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 600 }}>Status</th>
                                        <th style={{ padding: '12px', textAlign: 'center', fontWeight: 600 }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {servers.map((server, idx) => (
                                        <tr key={idx} style={{ borderBottom: '1px solid #dee2e6' }}>
                                            <td style={{ padding: '12px' }}>
                                                <span style={{ fontFamily: 'monospace', background: '#e9ecef', padding: '4px 8px', borderRadius: '4px' }}>
                                                    {server.port}
                                                </span>
                                            </td>
                                            <td style={{ padding: '12px' }}>{server.organisation_name}</td>
                                            <td style={{ padding: '12px' }}>
                                                <span style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    padding: '4px 12px',
                                                    borderRadius: '12px',
                                                    background: '#d4edda',
                                                    color: '#155724',
                                                    fontSize: '0.875rem',
                                                    fontWeight: 500
                                                }}>
                                                    <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#28a745' }}></span>
                                                    Running
                                                </span>
                                            </td>
                                            <td style={{ padding: '12px', textAlign: 'center' }}>
                                                <button
                                                    onClick={() => handleStopServer(server.port)}
                                                    className="btn btn-danger btn-sm"
                                                    style={{
                                                        padding: '6px 16px',
                                                        fontSize: '0.875rem',
                                                        background: '#dc3545',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    Stop
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div style={{ marginTop: '1rem', padding: '0.75rem', background: '#f8f9fa', borderRadius: '4px', fontSize: '0.875rem', color: '#6c757d' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span>🔄</span>
                                    <span>Auto-refreshing every 10 seconds...</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="rasa-manager-footer" style={{ justifyContent: 'space-between', padding: '1rem 1.5rem' }}>
                    <button
                        onClick={fetchServerStatus}
                        className="btn btn-secondary"
                        disabled={loading}
                    >
                        {loading ? 'Refreshing...' : 'Refresh Now'}
                    </button>
                    <button onClick={onClose} className="btn btn-secondary">Close</button>
                </div>
            </div>
        </div>
    );
};

export default RasaMonitor;

